export const SCAN_SIZE = 300;
export const OVERLAY_COLOR = "rgba(0, 0, 0, 0.6)";
